import {Theme, createStyles, lighten} from '@material-ui/core';
import {alpha} from '@material-ui/core/styles/colorManipulator';

const baseZIndex = 1;

export const businessBlockStyles = (theme: Theme) =>
	createStyles({
		root: {
			overflow: 'hidden',
			marginTop: theme.spacing(10),
			marginBottom: theme.spacing(10),
		},
		balloons: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-end',
			paddingBottom: theme.spacing(22),

			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				alignItems: 'flex-start',
				paddingBottom: theme.spacing(4),
			},
		},
		topBalloon: {
			backgroundColor: theme.palette.primary.main,
			borderRadius: theme.spacing(5),
			padding: theme.spacing(7.5, 2, 6.5, 10),
			zIndex: baseZIndex + 1,
			maxWidth: '90%',

			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				maxWidth: '100%',
				paddingLeft: theme.spacing(6),
				marginRight: theme.spacing(2.5),
			},
		},
		topBalloonText: {
			color: theme.palette.common.white,
			fontSize: theme.typography.pxToRem(26),
			lineHeight: theme.typography.pxToRem(36),

			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				fontSize: theme.typography.pxToRem(15),
				lineHeight: theme.typography.pxToRem(26),
			},
		},
		bottomBalloon: {
			backgroundColor: lighten(theme.palette.primary.light, 0.8),
			borderRadius: theme.spacing(5),
			padding: theme.spacing(20, 2, 6.5, 10),
			marginTop: theme.spacing(-1 * 15),
			zIndex: baseZIndex,

			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				paddingLeft: theme.spacing(7),
				borderTopRightRadius: 0,
				borderBottomRightRadius: 0,
				marginLeft: theme.spacing(2.5),
				alignSelf: 'flex-end',
			},
		},
		bottomBalloonText: {
			fontSize: theme.typography.pxToRem(20),
			lineHeight: theme.typography.pxToRem(26),

			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				fontSize: theme.typography.pxToRem(15),
				lineHeight: theme.typography.pxToRem(26),
			},
		},
		businessmanChair: {
			position: 'relative',
		},
		businessman: {
			pointerEvents: 'none',
			position: 'absolute',
			left: theme.spacing(-1 * 10),
			top: theme.spacing(15),
			zIndex: baseZIndex + 2,

			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				position: 'static',
				alignSelf: 'center',
				marginBottom: theme.spacing(-4),
			},
		},
		sliderBox: {
			textAlign: 'center',

			'& .slick-track': {
				[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
					display: 'flex',
					flexDirection: 'row-reverse',
				},
			},
		},
		sliderBoxTitle: {
			fontSize: theme.typography.pxToRem(20),
			lineHeight: theme.typography.pxToRem(26),
			paddingBottom: theme.spacing(4),
			paddingTop: theme.spacing(4),

			[theme.breakpoints.up(theme.breakpoints.values.xs)]: {
				padding: theme.spacing(0, 4, 2, 2.5),
				textAlign: 'center',
			},
			[theme.breakpoints.between(theme.breakpoints.values.xs, theme.breakpoints.values.sm)]: {
				fontSize: theme.typography.pxToRem(12),
				lineHeight: theme.typography.pxToRem(18),
				padding: theme.spacing(0, 4, 2, 2.5),
				textAlign: 'left',
			},
		},
		sliderCard: {
			padding: theme.spacing(2),
			backgroundColor: 'transparent',
			textAlign: 'left',

			'& .MuiCardActionArea-focusHighlight': {
				background: 'transparent',
			},
			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				padding: theme.spacing(0, 1),
			},
		},
		sliderCardContent: {
			paddingLeft: 0,

			'& small': {
				color: alpha(theme.palette.primary.main, 0.5),
			},
		},
		sliderCardMedia: {
			borderRadius: theme.spacing(1),
			boxShadow: ' 0px 14px 32px ' + alpha(theme.palette.primary.main, 0.13),
		},
		moreLink: {
			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				marginLeft: theme.spacing(2.5),
			},
		},
	});
